import { SelectionModel } from '@angular/cdk/collections';
import { Location } from '@angular/common';
import { AfterViewInit, Component, DoCheck, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatSelectionListChange, MatListModule } from '@angular/material/list';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { ELIMSTest } from 'src/app/domain/ELIMS/ELIMS-test';
import { EComparaisonLQ } from 'src/app/domain/enum/comparaison-lq';
import { Test } from 'src/app/domain/test';
import { ELIMSService } from 'src/app/services/ELIMS.service';
import { TestService } from 'src/app/services/test.service';
import { StringConverter } from '../../tools/ui/string-converter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-test-management',
    templateUrl: './test-management.component.html',
    styleUrl: './test-management.component.scss',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatSlideToggleModule, MatSelectModule, MatOptionModule, MatChipsModule, MatIconModule, MatButtonModule, PreventDoubleClickDirective, MatListModule]
})
export class TestManagementComponent implements OnInit, AfterViewInit, DoCheck {

    @ViewChild('fullPanel') fullContainer!: ElementRef;
    @ViewChild('topPanel') topContainer!: ElementRef;
    public ComparaisonLQList: string[] = Object.values(EComparaisonLQ)
        .filter(x => !isNaN(Number(x)))
        .map(x => StringConverter.getComparaisonLQName(x as EComparaisonLQ));

    public AvailableUnitList: string[] = [];

    Model: Test = new Test();
    IsCreation: boolean = true;

    keywords: string[] = [];
    formControl = new FormControl(['angular']);
    AvailableElimsTestList: ELIMSTest[] = []
    ProductGroupCode: string = ''
    TestCode: string = ''
    TestGroupCode: string = ''
    IsStrictSearch: boolean = false;
    // PageHeight: string = '';
    NeedConversion: boolean = false;

    get CanConvert() {
        return this.Model.ElimsUnitName.startsWith('m') || this.Model.ElimsUnitName.startsWith('n') || this.Model.ElimsUnitName.startsWith('µ')
    }

    constructor(
        private snackBar: MatSnackBar,
        private _location: Location,
        private testService: TestService,
        private route: ActivatedRoute,
        private ELIMSService: ELIMSService) {
        // if (data) {
        //     this.Model = Object.assign({}, data.test ?? new Test());
        //     this.Model.ElimsTestList = Object.assign([], data.test?.ElimsTestList ?? []);

        // }

    }

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {
        if (this.route.snapshot.params['productGroupCode']) {
            this.ProductGroupCode = this.route.snapshot.params['productGroupCode'];
        }
        if (this.route.snapshot.params['testCode']) {
            this.IsCreation = false;
            this.getTestByCode(this.route.snapshot.params['testCode'])
        }
        if (this.route.snapshot.params['testGroupCode']) {

            this.TestGroupCode = this.route.snapshot.params['testGroupCode']
        }

    }

    ngDoCheck(): void {
        // if (this.fullContainer && this.topContainer) {
        //     console.log(this.fullContainer.nativeElement.clientHeight)
        //     this.PageHeight = `calc(${this.fullContainer.nativeElement.clientHeight}px - ${this.topContainer.nativeElement.clientHeight}px - 200px)` // 80px for the height of the button line
        // }
    }

    removeKeyword(keyword: string) {
        const index = this.keywords.indexOf(keyword);
        if (index >= 0) {
            this.keywords.splice(index, 1);
        }
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our keyword
        if (value) {
            this.keywords.push(value);
        }

        // Clear the input value
        event.chipInput!.clear();
    }

    search() {
        this.ELIMSService.getTestList(this.keywords, this.ProductGroupCode, this.IsStrictSearch).subscribe(x => {
            this.AvailableElimsTestList = x;
            if (this.Model.ElimsTestList.length >= 1) {
                this.AvailableElimsTestList = this.AvailableElimsTestList.filter(x => x.ElimsUnitName === this.Model.ElimsTestList[0].ElimsUnitName && !this.Model.ElimsTestList.find(y => y.ParameterCode === x.ParameterCode && y.TestCode === x.TestCode))
            }
        })
    }

    onSelection(e: MatSelectionListChange, v: SelectionModel<any>) {

        this.Model.ElimsTestList.push(...[e.options[0].value]);
        if (!this.Model.ElimsUnitName) {
            this.Model.ElimsUnitName = (e.options[0].value as ELIMSTest).ElimsUnitName;
            this.Model.DisplayedUnitName = (e.options[0].value as ELIMSTest).ElimsUnitName;
        }
        this.AvailableElimsTestList = this.AvailableElimsTestList.filter(x => x.ElimsUnitName === (e.options[0].value as ELIMSTest).ElimsUnitName && !this.Model.ElimsTestList.find(y => y.ParameterCode === x.ParameterCode && y.TestCode === x.TestCode))

        this.handleConversion();
    }

    ConversionChanged(event: MatSlideToggleChange) {
        if (event.checked)
            this.handleConversion();
    }

    private handleConversion() {

        if (this.Model.ElimsUnitName.startsWith('m'))
            this.AvailableUnitList = ['µ' + this.Model.ElimsUnitName.substring(1)]
        else if (this.Model.ElimsUnitName.startsWith('µ'))
            this.AvailableUnitList = ['m' + this.Model.ElimsUnitName.substring(1), 'n' + this.Model.ElimsUnitName.substring(1)]
        else if (this.Model.ElimsUnitName.startsWith('n'))
            this.AvailableUnitList = ['µ' + this.Model.ElimsUnitName.substring(1)]
    }

    removeElimsTest(test: ELIMSTest) {
        _.remove(this.Model.ElimsTestList, test)
        if (this.Model.ElimsTestList.length === 0) {
            this.Model.ElimsUnitName = ''
            this.Model.DisplayedUnitName = ''
            this.search()
        }
    }

    getTestByCode(code: string) {
        this.testService.getTestByCode(code).subscribe(x => {
            this.Model = x;
        })
    }

    updateTest() {
        this.testService.update(this.Model).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Test modifié !', this.snackBar);
                this.goBack()
            }
        })
    }

    createTest() {
        this.testService.create(this.Model, this.TestGroupCode).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Test modifié !', this.snackBar);
                this.goBack()
            }
        })
    }

    CanSave() {
        return this.Model.ElimsTestList.length >= 1 && this.Model.Name;
    }

    onConfirm() {
        if (this.CanSave()) {
            this.IsCreation ? this.createTest() : this.updateTest();
        }
    }

    goBack() {
        this._location.back();
    }
}
